import React, { useState, useRef } from 'react';
import { Layout, Typography, Button, notification, Divider } from 'antd';
import NumberSelector from './NumberSelector'; // Asegúrate que este componente pueda recibir los colores
import Cart from './Cart';
import WinnerForm from './WinnerForm';
import { FaGift, FaTrophy, FaDice } from 'react-icons/fa'; // Iconos para los premios

const { Header, Content } = Layout;
const { Title, Text } = Typography;

function App() {
  const [cart, setCart] = useState([]);
  const [winners, setWinners] = useState([]);

  // Ref para hacer scroll al formulario
  const formRef = useRef(null);

  // Función para manejar el carrito y la selección de números
  const handleSelectNumber = (number) => {
    setCart((prevCart) => [...prevCart, number]);
  };

  const handleRemoveNumber = (number) => {
    setCart((prevCart) => prevCart.filter((n) => n !== number));
  };

  // Manejar el envío del formulario
  const handleWinnerFormSubmit = (data) => {
    console.log('Datos del formulario:', data);
    // Aquí puedes manejar lo que se haga después de un pago exitoso
    notification.success({
      message: '¡Gracias por participar!',
      description: 'Tu pago fue exitoso y pronto recibirás tu premio.',
    });
  };

  // Función para hacer scroll hasta el formulario de compra
  const scrollToForm = () => {
    formRef.current.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  return (
    <Layout>
      {/* Portada con imagen atractiva */}
      <Header style={{ padding: 0 }}>
        <div
          style={{
            background: `url('/portada.jpg') no-repeat center center`,
            backgroundSize: 'cover',
            textAlign: 'center',
            padding: '120px 20px',
            color: 'white',
            borderBottom: '4px solid #d4af37',
            position: 'relative',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: 'rgba(0, 0, 0, 0.6)', // Fondo oscuro translúcido
              zIndex: 1,
            }}
          ></div>

          <div style={{ position: 'relative', zIndex: 2 }}>
            <Title
              style={{
                fontSize: '4rem',
                fontFamily: 'cursive',
                marginBottom: '20px',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                color: '#ff6b6b',
              }}
            >
              ¡Melitico y Ricolino!
            </Title>
            <Text
              style={{
                fontSize: '1.8rem',
                fontWeight: 'bold',
                marginBottom: '30px',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                color: '#fff',
              }}
            >
              ¡Compra un número y gana grandes premios!
            </Text>
            <Button
              onClick={scrollToForm} // Llamada a la función de scroll
              type="primary"
              size="large"
              style={{
                backgroundColor: '#ff6b6b',
                borderColor: '#ff6b6b',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                padding: '10px 20px',
                boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
              }}
            >
              ¡Participa Ahora!
            </Button>
          </div>
        </div>
      </Header>

      <Content style={{ padding: '40px', backgroundColor: '#f4f4f4', marginTop: '550px' }}>
        {/* Mostrar premios e instrucciones */}
        <div style={{ marginTop: '60px', textAlign: 'center' }}>
          <Title level={2} style={{ color: '#ff6b6b', fontFamily: 'cursive' }}>
            Premios Increíbles
          </Title>
          <Text style={{ fontSize: '1.2rem', display: 'block', marginBottom: '10px' }}>
            ¡Grandes premios te esperan! Aquí están los premios que podrías ganar:
          </Text>
       <Text style={{ textAlign: 'center', fontSize: '2.5rem', fontWeight: 'bold', marginBottom: '20px' }}>
       Número de   <br></br>
  Ejemplo <br></br>
  <span style={{ fontSize: '4rem', color: '#2c3e50' }}>
    <span style={{
      borderRadius: '50%', 
      backgroundColor: 'white', 
      padding: '15px', 
      marginRight: '10px', 
      color: '#d4af37', 
      fontWeight: 'bold'
    }}>2859</span>
 
  </span>
</Text>

<div style={{ fontSize: '1.2rem', marginBottom: '20px', color: '#333' }}>
  <ul style={{ listStyleType: 'none', padding: 0, marginLeft: '0' }}>
    <li style={{ marginBottom: '15px' }}>
      <FaTrophy style={{ color: '#ff6b6b', marginRight: '10px' }} />
      <strong>🏆 Premio Mayor</strong>
      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#ff6b6b' }}>
        <span style={{
          borderRadius: '50%', 
          backgroundColor: '#ffe1e1', 
          padding: '10px', 
          marginRight: '10px'
        }}>859</span>
      </span>
      <span style={{ fontSize: '1.5rem' }}>: $5,000,000</span>
    </li>

    <li style={{ marginBottom: '15px' }}>
      <FaGift style={{ color: '#d4af37', marginRight: '10px' }} />
      <strong>🎰 Premio Menor</strong>
      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#d4af37' }}>
        <span style={{
          borderRadius: '50%', 
          backgroundColor: '#f8e6a1', 
          padding: '10px', 
          marginRight: '10px'
        }}>285</span>
      </span>
      <span style={{ fontSize: '1.5rem' }}>: $2,000,000 - Con las 3 primeras cifras</span>
    </li>

    <li style={{ marginBottom: '15px' }}>
      <FaDice style={{ color: '#00b894', marginRight: '10px' }} />
      <strong>💰 Premio Mínimo</strong>
      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#00b894' }}>
        <span style={{
          borderRadius: '50%', 
          backgroundColor: '#d3f8e2', 
          padding: '10px', 
          marginRight: '10px'
        }}>958</span>
      </span>
      <span style={{ fontSize: '1.5rem' }}>: $1,000,000</span>
    </li>

    <li style={{ marginBottom: '15px' }}>
      <FaGift style={{ color: '#00cec9', marginRight: '10px' }} />
      <strong>🎉 20 ganadores de $100,000:</strong> 
      <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#00cec9' }}>
        Entregado al azar a través de nuestro Instagram (@deinstagram)
      </span>
    </li>
  </ul>
</div>


          <Text
            style={{
              fontSize: '1.2rem',
              display: 'block',
              marginTop: '20px',
              fontWeight: 'bold',
              color: '#333',
            }}
          >
            ¡Participa y gana grandes premios! Los números son limitados, ¡no dejes pasar la oportunidad!
          </Text>
        </div>

        {/* Sección de participación siempre visible */}
        <div style={{ marginTop: '40px', textAlign: 'center' }}>
          <Text style={{ fontSize: '1.8rem', textAlign: 'center', color: '#ff6b6b', fontWeight: 'bold' }}>
            <span role="img" aria-label="trebol" style={{ marginRight: '8px' }}>🍀</span>
            ¡Elige tu Número de la Suerte!
          </Text>
        </div>

        {/* Aquí pasamos los colores para los números seleccionados y disponibles */}
        <NumberSelector
          onSelectNumber={handleSelectNumber}
          cart={cart}
          availableColor="#2ecc71" // Verde para números disponibles
          selectedColor="#e74c3c" // Rojo para números seleccionados
        />
        <Cart cart={cart} onRemoveNumber={handleRemoveNumber} />

        {/* Formulario de captura de datos manteniendo el estilo */}
        <div
          ref={formRef}
          style={{
            maxWidth: '500px',
            margin: '0 auto',
            backgroundColor: 'white',
            borderRadius: '10px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
          }}
        >
          <WinnerForm onSubmit={handleWinnerFormSubmit} cart={cart}/>
        </div>
      </Content>
    </Layout>
  );
}

export default App;
